import { new__cn as cn, createTwStyle } from '../util';
import type { VLabelProps } from './type';

const twStyle = createTwStyle<VLabelProps>();

export default twStyle({
  container: ({ disabled }) => [
    cn(
      'relative w-fit text-body-sm capitalize select-none',
      disabled ? ['text-gray-400!'] : ['text-gray-600'],
    ),
  ],

  label: () => cn('inline-block'),

  requiredBullet: () => cn('h-1 w-1 min-w-1', 'bg-error-500', 'rounded-full'),
});
